import React, { useState, useEffect } from 'react';
import { MoreVertical, Plus, Share2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SongMenu = ({ song, user }) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [playlists, setPlaylists] = useState([]);
  const [showPlaylistDropdown, setShowPlaylistDropdown] = useState(false);

  useEffect(() => {
    if (showMenu && user) {
      fetchPlaylists();
    }
  }, [showMenu, user]);

  const fetchPlaylists = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/playlists/me`,
        {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
        }
      );
      if (response.ok) {
        const data = await response.json();
        console.log('Fetched playlists:', data);
        setPlaylists(data);
      }
    } catch (error) {
      console.error('Failed to fetch playlists:', error);
    }
  };

  const handleAddToPlaylist = () => {
    if (!user) {
      if (window.confirm('Login or create a free account to use this feature. Go to login page?')) {
        navigate('/login');
      }
      setShowMenu(false);
      return;
    }
    setShowPlaylistDropdown(!showPlaylistDropdown);
  };

  const addToPlaylist = async (playlistId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/playlists/${playlistId}/songs/${song.id}`,
        {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
        }
      );
      
      if (response.ok) {
        alert('Song added to playlist!');
        setShowMenu(false);
        setShowPlaylistDropdown(false);
        // Refresh the page if we're on a playlist page to show updated songs
        if (window.location.pathname.includes('/playlist/')) {
          window.location.reload();
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        alert(errorData.detail || 'Failed to add song to playlist');
      }
    } catch (error) {
      console.error('Failed to add song to playlist:', error);
      alert('Failed to add song to playlist');
    }
  };

  const shareSong = () => {
    const shareUrl = `${window.location.origin}/song/${song.id}`;
    navigator.clipboard.writeText(shareUrl);
    alert('Song link copied to clipboard!');
    setShowMenu(false);
  };

  return (
    <div className="song-menu-container">
      <button 
        className="song-menu-button"
        onClick={(e) => {
          e.stopPropagation();
          setShowMenu(!showMenu);
        }}
      >
        <MoreVertical size={20} />
      </button>

      {showMenu && (
        <>
          <div 
            className="menu-overlay" 
            onClick={() => {
              setShowMenu(false);
              setShowPlaylistDropdown(false);
            }}
          />
          <div className="song-menu">
            <div className="menu-item-with-submenu">
              <button 
                className="menu-item"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddToPlaylist();
                }}
              >
                <Plus size={16} />
                Add to Playlist
              </button>
              
              {showPlaylistDropdown && user && (
                <div className="playlist-dropdown">
                  {playlists.length === 0 ? (
                    <div className="empty-playlist-msg">
                      No playlists yet. Create one from the sidebar!
                    </div>
                  ) : (
                    playlists.map(playlist => (
                      <button
                        key={playlist.id}
                        className="playlist-dropdown-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          addToPlaylist(playlist.id);
                        }}
                      >
                        🎵 {playlist.name} ({playlist.song_ids?.length || 0})
                      </button>
                    ))
                  )}
                </div>
              )}
            </div>
            
            <button 
              className="menu-item"
              onClick={(e) => {
                e.stopPropagation();
                shareSong();
              }}
            >
              <Share2 size={16} />
              Share Song
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SongMenu;
